export const userDeviceDetect = () => {
    const { userAgent } = navigator
    const isPortable = Boolean(userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i))
    const isAndroid = Boolean(userAgent.match(/Android|BlackBerry|Opera Mini|IEMobile|WPDesktop/i))
    const isIos = Boolean(userAgent.match(/iPhone|iPad|iPod/i))

    return { isPortable, isAndroid, isIos }
}

export const userBrowserDetect = () => {
    const { userAgent } = navigator
    const isSafari = Boolean(userAgent.match(/safari/i))
    const isFirefox = Boolean(userAgent.match(/firefox|fxios/i))
    const isChrome = Boolean(userAgent.match(/chrome|chromium|crios/i))
    const isOpera = Boolean(userAgent.match(/opr\//i))
    const isEdge = Boolean(userAgent.match(/edg/i))

    return { isSafari, isFirefox, isChrome, isOpera, isEdge }
}
